export const JOB_STATUS = {
  COMPLETED: "COMPLETED",
  FAILED: "FAILED"
};

export const JOB_OUTCOME = {
  SYNCED: "synced",
  SKIPPED: "skipped"
};

// Kinds of user-facing result toast (not job data; see JOB_OUTCOME for that).
export const SYNC_RESULT = {
  SUCCESS: "success",
  FAILURE: "failure",
  SKIPPED: "skipped",
  STILL_RUNNING: "stillRunning"
};

export const PCC_SYNC_STATUS = {
  QUEUED: "queued",
  UNCONFIRMED: "unconfirmed",
  FAILED: "failed"
};

export const POLL_INTERVAL_MS = 3000;
export const POLL_MAX_WAIT_MS = 15 * 60 * 1000;
export const POLL_NOT_FOUND_GRACE_MS = 30000;
export const POLL_REQUEST_TIMEOUT_MS = 10000;
export const HTTP_UNAUTHORIZED = 401;
export const HTTP_FORBIDDEN = 403;
export const HTTP_NOT_FOUND = 404;

export const SYNC_MESSAGES = {
  IN_PROGRESS: "Syncing from PointClickCare… Please do not refresh or close this browser tab/window.",
  SUCCESS: "Medications and immunizations synced from PointClickCare.",
  FAILURE: "PointClickCare sync failed. Use Sync Treatments / Sync Immunizations to retry.",
  SKIPPED: "Resident not found in PointClickCare. Nothing was synced.",
  STILL_RUNNING: "PointClickCare sync is still running. Check Treatments and Immunizations later."
};
